import React, { useContext, useState } from 'react'
import { useIntl } from 'react-intl'
import PropTypes from 'prop-types'
import LinkWithStatus from '../../../../../common/LinkWithStatus'
import { ConnectorPinsContext } from '../../context/context'
import {
  createSearchParams,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom'
import { NavContext } from '../../../../../../context/global_context'

const SearchConnectorsButton = (props) => {
  const intl = useIntl()
  const [state, dispatch] = useContext(ConnectorPinsContext)
  const [navState, navDispatch] = useContext(NavContext)
  let { vehicle, connector_id } = useParams()
  const [searchParams, setSearchParams] = useSearchParams()
  const navigate = useNavigate()

  const connectorsUrl = () => {
    navigate(
      `/vehicles/${vehicle}/dtcs/listing/mappings/${connector_id}/?${createSearchParams(
        {
          dtc_id: searchParams.getAll('dtc_id'),
          connector_name: searchParams.get('connector_name'),
          ...searchParams.has('start_q') ? {start_q: searchParams.get('start_q')} : {},
          ...searchParams.has('end_q') ? {end_q: searchParams.get('end_q')} : {},
          dtc_mapping_type: state?.dtc_mapping_type,
          query_type: state?.query_type,
          selected_pins: state?.selected_pins,
          search_old_levels: false,
        }
      )}`
    )
  }

  useState(() => {
    if (navState?.destination_only && state?.selected_pins?.length > 0) {
      setTimeout(() => {
        connectorsUrl()
      }, 200)
    }
  }, [state?.selected_pins, navState?.destination_only])

  const text =
    searchParams.get('dtc_mapping_type') === 'end'
      ? intl.formatMessage({ id: 'dtcs.connectorMapping.filterStartConnectors' })
      : intl.formatMessage({ id: 'dtcs.connectorMapping.filterEndConnectors' })

  return (
    <LinkWithStatus
      type="primary"
      className={`find-button`}
      testId="dtc-filter-connectors"
      disabled={navState?.destination_only || state?.selected_pins?.length < 1 ? true : false}
      onClickFunc={() => {
        connectorsUrl()
      }}
    >
      {text}
    </LinkWithStatus>
  )
}

SearchConnectorsButton.propTypes = {}

export default SearchConnectorsButton
